import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledTextField } from '@/shared/components/ui/form/components/text-field/text-field.styled';
import { TTextFieldProps } from '@/shared/components/ui/form/components/text-field/text-field.types';
import { DEFAULT_ERROR_KEY } from '@/shared/utils/validation';

export const TextField: React.FC<TTextFieldProps> = ({
  size,
  hideOptionalLabel,
  helperText,
  ...props
}) => {
  const { t } = useTranslation();

  const isOptional = () => {
    if (props.required || hideOptionalLabel) {
      return;
    }
    return `(${t('ui:form.optional')})`;
  };

  const getHelperText = () => {
    if (props.error) {
      if (helperText && helperText !== DEFAULT_ERROR_KEY) {
        return t(`error:${helperText}`);
      }

      if (props.required) {
        return t('ui:form.field_required', {
          field: props.label ?? t('ui:form.field'),
        });
      }
    }

    return helperText;
  };

  return (
    <StyledTextField
      $size={size}
      $optional={isOptional()}
      variant="outlined"
      helperText={getHelperText()}
      InputLabelProps={{
        // this is the deprecated implementation, but the new slotProps does not work
        shrink: true,
      }}
      {...props}
    />
  );
};
